export const SET = 'pendingWithdrawals:set';
export const START_LOADING = 'pendingWithdrawals:start_loading';
export const RESET = 'pendingWithdrawals:reset';
